var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverdueAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.716,
    height: 17.238,
    viewBox: "0 0 19.716 17.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle",
    "data-name": "Icon feather-alert-triangle",
    transform: "translate(0.774 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38050",
    "data-name": "Path 38050",
    d: "M9.925,5.183,2.561,17.476a1.739,1.739,0,0,0,1.487,2.608H18.775a1.739,1.739,0,0,0,1.487-2.608L12.9,5.183a1.739,1.739,0,0,0-2.973,0Z",
    transform: "translate(-2.328 -4.346)",
    fill: "none",
    stroke: "#e6171a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38051",
    "data-name": "Path 38051",
    d: "M18,13.5v3.478",
    transform: "translate(-8.917 -8.194)",
    fill: "none",
    stroke: "#e6171a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38052",
    "data-name": "Path 38052",
    d: "M18,25.5h0",
    transform: "translate(-8.917 -13.239)",
    fill: "none",
    stroke: "#e6171a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueAlert);
export default __webpack_public_path__ + "static/media/overdue-alert.d126ea4258123a9ee421af431c36cedf.svg";
export { ForwardRef as ReactComponent };